const typesTiposUsuario = {
  asesor: "asesor",
  estudiante: "estudiante",
  empleado: "empleado",
  administrador: "administrador",
  vendedor: "vendedor",
  invitado: "invitado",
  cortesia: "cortesia",
  lecturaVeloz: "lectura_veloz",
  asesorLectura: "asesor_lectura",
  capacitador: "capacitador",
  gestion: "gestión de personal",
  cobranza: "cobranza",
  todosUsuarios: [
    "asesor",
    "estudiante",
    "empleado",
    "administrador",
    "capacitador",
    "vendedor",
    "cobranza"
    // "gestión de personal"
  ],
  usuariosEmpresariales: ["asesor", "empleado", "administrador", "capacitador"],
  usuariosPrueba: ["asesor", "administrador", "estudiante"],
};

export default typesTiposUsuario;
